<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__gamerankrecord}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="用户/账号">
          <el-input v-model="dataForm.accountName" placeholder="请输入用户姓名/账号" clearable></el-input>
        </el-form-item>
        <el-form-item label="开户时间">
          <el-date-picker
                  v-model="dataForm.openStartTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="年/月/日">
          </el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
                  v-model="dataForm.openEndTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="/年/月/日">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="dataForm.activationStatus"  placeholder="全部" clearable>
            <el-option label="已激活" value="1"></el-option>
            <el-option label="未激活" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="激活时间">
          <el-date-picker
                  v-model="dataForm.activationStartTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="年/月/日">
          </el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
                  v-model="dataForm.activationEndTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="/年/月/日">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="参与时间">
          <el-date-picker
                  v-model="dataForm.participateStartTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="年/月/日">
          </el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
                  v-model="dataForm.participateEndTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="/年/月/日">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="游戏时间">
          <el-date-picker
                  v-model="dataForm.gameRankStartTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="年/月/日">
          </el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
                  v-model="dataForm.gameRankEndTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="/年/月/日">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button @click="queryDataList()" >搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle('游戏活动记录')">导出</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column fixed type="index" label="序号" :index="indexMethod" width="80"></el-table-column>
        <el-table-column prop="account" label="账号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="accountName" label="用户姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="openAccountTime" label="开户时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="activationStatus" label="激活状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.activationStatus === 1" size="small" type="success">已激活</el-tag>
            <el-tag v-else-if="scope.row.activationStatus === 2" size="small" type="warning">未激活</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="activationTime" label="激活时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="participateInTime" label="参与时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="gameRankScore" label="游戏积分" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bonus" label="美元" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bonus1" label="人民币" header-align="center" align="center"></el-table-column>
        <el-table-column prop="receivePrizeTime" label="游戏时间" header-align="center" align="center"></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from './import/view-module'
import Url from '@/views/crs/util/url'
export default {
  mixins: [mixinViewModule],
  props:['gameRankId'],
  watch:{
      gameRankId:{
        handler(val){
          if(val){
            this.dataForm.gameRankId = val
          }
        },
         immediate:true
      }
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: Url.gameRank.base+'/activity/gameRankReCord/page',
        getDataListIsPage: true,
        deleteURL: Url.gameRank.base+'/activity/gameRankReCord',
        deleteIsBatch: true,
        exportURL: Url.gameRank.base+'/activity/gameRankReCord/export1'
      },
      dataForm: {
        gameRankId: "",
        accountName:"",
        openStartTime:"",
        openEndTime:"",
        activationStatus:"",
        activationStartTime:"",
        activationEndTime:"",
        participateStartTime:"",
        participateEndTime:"",
        gameRankStartTime:"",
        prizeName:"",
        gameRankEndTime:"",
        gameRankScore:""
      },
      selectList:{
        recordPrizeLists:[]
      },
         indexMethod(index) {
      return ++index;
    },
    }
  },
  methods:{
  },
  mounted(){
    this.queryDataList();
  }
}
</script>
